import React from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function __values$1(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$1(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

var hasOwn = {}.hasOwnProperty;

function isEqualShallow(a, b) {
  if (a === b) return true;
  if (!a || !b) return false;
  var akeys = Object.keys(a);
  var bkeys = Object.keys(b);
  if (akeys.length !== bkeys.length) return false;
  var n = akeys.length;

  while (n--) {
    var k = akeys[n];

    if (!hasOwn.call(b, k) || a[k] !== b[k]) {
      if (typeof a[k] === 'function' && typeof b[k] === 'function') {
        continue;
      }

      return false;
    }
  }

  return true;
}

var contextConsumerTypeSymbol = Symbol('ContextSelectionConsumer');
var contextListeners = new Map();

function useContextSelection(Context, selection) {
  if (process.env.NODE_ENV !== 'production') {
    // @ts-ignore
    if (Context.Consumer.$$type !== contextConsumerTypeSymbol) {
      throw new Error("You need to provide a 'Context' instance created with 'createContext()' function from 'use-context-selection' library.");
    }
  }

  var contextValue = React.useContext(Context);

  var _a = __read$1(React.useState(selection(contextValue)), 2),
      currentSelection = _a[0],
      forceUpdate = _a[1];

  var listener = React.useRef({
    selection: selection,
    forceUpdate: forceUpdate
  });
  React.useEffect(function () {
    var listeners = contextListeners.get(Context);
    listeners.add(listener.current);
    return function () {
      var listeners = contextListeners.get(Context);
      listeners.delete(listener.current);
    };
  }, []);
  return currentSelection;
}

function createContextConsumer(Context) {
  var ContextSelectionConsumer = function ContextSelectionConsumer(_a) {
    var children = _a.children,
        _b = _a.selection,
        selection = _b === void 0 ? function (store) {
      return store;
    } : _b;
    var contextValue = useContextSelection(Context, selection);
    return children(contextValue);
  };

  ContextSelectionConsumer.$$type = contextConsumerTypeSymbol;
  return ContextSelectionConsumer;
}

function createContextDispatcher(listeners, equalityFn) {
  if (equalityFn === void 0) {
    equalityFn = isEqualShallow;
  }

  return function (oldValue, newValue) {
    var e_1, _a;

    try {
      for (var listeners_1 = __values$1(listeners), listeners_1_1 = listeners_1.next(); !listeners_1_1.done; listeners_1_1 = listeners_1.next()) {
        var listener = listeners_1_1.value;
        var newResult = listener.selection(newValue);

        if (!equalityFn(newResult, listener.selection(oldValue))) {
          listener.forceUpdate(newResult);
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return 0;
  };
}

function createContext(initValue, equalityFn) {
  var listeners = new Set(); // @ts-ignore

  var Context = React.createContext(initValue, createContextDispatcher(listeners, equalityFn));
  contextListeners.set(Context, listeners); // @ts-ignore

  Context.Consumer = createContextConsumer(Context);
  return Context;
}

function parse(path) {
  var pathParts = createParser(path);
  return function (object) {
    if (!path) {
      return object;
    }

    var value = object;

    for (var i = 0; i < pathParts.length; i++) {
      value = value[pathParts[i]];
    }

    return value;
  };
}

function createParser(path) {
  var parts = [];
  var word = [];
  var char = '';
  var bracesOpen = false;

  function finishWordIfNotEmpty() {
    if (word.length > 0) {
      parts.push(word.join(''));
      word.length = 0;
    }
  }

  for (var i = 0; i < path.length; i++) {
    char = path[i];

    switch (char) {
      case '.':
        if (bracesOpen) {
          word.push(char);
          continue;
        }

        finishWordIfNotEmpty();
        break;

      case '[':
        if (bracesOpen) {
          throw 'Parse error: unexpected character "["';
        }

        finishWordIfNotEmpty();
        bracesOpen = true;
        break;

      case ']':
        if (!bracesOpen || word.length === 0) {
          throw 'Parse error: unexpected character "]"';
        }

        finishWordIfNotEmpty();
        bracesOpen = false;
        break;

      default:
        word.push(char);
    }
  }

  if (bracesOpen) {
    throw 'Parse error: unclosed brace "[" found';
  }

  finishWordIfNotEmpty();
  return parts;
}

function splitOnColon(string) {
  var i = string.length - 1;

  for (; i >= 0; i--) {
    if (string[i] === ']') {
      break;
    }

    if (string[i] === ':') {
      return [string.slice(0, i), string.slice(i + 1)];
    }
  }

  return [string];
}

function parseSelectors(selector) {
  if (selector instanceof Array) {
    return selector.reduce(function (object, current) {
      var _a = splitOnColon(current),
          keyOnStore = _a[0],
          mappedKey = _a[1];

      var lastDotPosition = keyOnStore.lastIndexOf('.');
      var getter = parse(keyOnStore);
      object[mappedKey || keyOnStore.slice(lastDotPosition + 1)] = getter;
      return object;
    }, {});
  } else if (typeof selector === 'object') {
    var parsedSelector_1 = {};
    Object.entries(selector).forEach(function (_a) {
      var key = _a[0],
          value = _a[1];

      if (typeof value === 'string') {
        var getter = parse(value);
        parsedSelector_1[key] = getter;
      } else {
        parsedSelector_1[key] = value;
      }
    });
    return parsedSelector_1;
  }

  return selector;
}

function executeParsedSelectors(parsedSelectors, data, props) {
  if (props === void 0) {
    props = {};
  }

  if (typeof parsedSelectors === 'function') {
    return parsedSelectors(data, props);
  }

  var selections = {};

  for (var key in parsedSelectors) {
    try {
      selections[key] = parsedSelectors[key](data, props);
    } catch (e) {}
  }

  return selections;
}

function connectContext(Context, Component, options) {
  if (options === void 0) {
    options = {};
  }

  return React.memo(function (props) {
    var _a = getContextSelection(Context, options, props),
        selectedState = _a[0],
        selectedActions = _a[1];

    var mergedProps = getMergedProps(selectedState, selectedActions, props, options.computedSelectors);
    return React.createElement(Component, _assign({}, mergedProps));
  });
}

function connectContextFactory(Context) {
  return function (Component, options) {
    if (options === void 0) {
      options = {};
    }

    var parsedOptions = normalizedContextOptions(options);
    parsedOptions.stateSelectors = parseSelectors(parsedOptions.stateSelectors);
    parsedOptions.actionSelectors = parseSelectors(parsedOptions.actionSelectors);
    return connectContext(Context, Component, parsedOptions);
  };
}

function useConnectedContextFactory(Context) {
  return function (options) {
    if (options === void 0) {
      options = {};
    }

    var parsedOptions = React.useMemo(function () {
      var parsedOptions = normalizedContextOptions(options);
      parsedOptions.stateSelectors = parseSelectors(parsedOptions.stateSelectors);
      parsedOptions.actionSelectors = parseSelectors(parsedOptions.actionSelectors);
      return parsedOptions;
    }, [options]);

    var _a = getContextSelection(Context, parsedOptions),
        selectedState = _a[0],
        selectedActions = _a[1];

    var mergedProps = getMergedProps(selectedState, selectedActions, {}, parsedOptions.computedSelectors);
    return mergedProps;
  };
}

function getContextSelection(Context, options, props) {
  if (options === void 0) {
    options = {};
  }

  if (props === void 0) {
    props = {};
  }

  var _a = React.useMemo(function () {
    return normalizedContextOptions(options);
  }, [options]),
      stateSelectors = _a.stateSelectors,
      actionSelectors = _a.actionSelectors;

  return useContextSelection(Context, function (store) {
    var selectedState = executeParsedSelectors(stateSelectors, store.state, props);
    var selectedActions = executeParsedSelectors(actionSelectors, store.actions, props);
    return [selectedState, selectedActions];
  });
}

function mergedConnectContextFactory(contexts) {
  return function (Component, options) {
    if (options === void 0) {
      options = {};
    }

    var parsedOptions = normalizedContextOptions(options);
    parsedOptions.stateSelectors = parseSelectors(parsedOptions.stateSelectors);
    parsedOptions.actionSelectors = parseSelectors(parsedOptions.actionSelectors);
    return React.memo(function (props) {
      var mergedProps = getMergedPropsFromContexts(contexts, parsedOptions, props); // DEPRECATED

      if (parsedOptions.afterMerge) {
        var afterMergeProps = Object.assign({}, mergedProps, parsedOptions.afterMerge(mergedProps) || {});
        return React.createElement(Component, _assign({}, afterMergeProps));
      }

      return React.createElement(Component, _assign({}, mergedProps));
    });
  };
}

function useMergedConnectedContextFactory(contexts) {
  return function (options) {
    if (options === void 0) {
      options = {};
    }

    var parsedOptions = React.useMemo(function () {
      var parsedOptions = normalizedContextOptions(options);
      parsedOptions.stateSelectors = parseSelectors(parsedOptions.stateSelectors);
      parsedOptions.actionSelectors = parseSelectors(parsedOptions.actionSelectors);
      return parsedOptions;
    }, [options]);
    return getMergedPropsFromContexts(contexts, parsedOptions);
  };
}

function getMergedPropsFromContexts(contexts, options, props) {
  if (props === void 0) {
    props = {};
  }

  if (contexts instanceof Array) {
    // DEPRECATE: just use Object notation
    return getMergedPropsFromContextsArray(contexts, options, props);
  }

  var mergedContext = Object.keys(contexts).reduce(function (mergedContext, key) {
    var _a = useContextSelection(contexts[key], function (store) {
      var _a, _b;

      var selectedState = executeParsedSelectors(options.stateSelectors, (_a = {}, _a[key] = store.state, _a), props);
      var selectedActions = executeParsedSelectors(options.actionSelectors, (_b = {}, _b[key] = store.actions, _b), props);
      return [selectedState, selectedActions];
    }),
        selectedState = _a[0],
        selectedActions = _a[1];

    Object.assign(mergedContext.selectedState, selectedState);
    Object.assign(mergedContext.selectedActions, selectedActions);
    return mergedContext;
  }, {
    selectedState: {},
    selectedActions: {}
  }); // TODO: rename getMergedProps to something related with computedSelectors, and create a new getMergedProps that all these 3 steps

  var mergedProps = getMergedProps(mergedContext.selectedState, mergedContext.selectedActions, props, options.computedSelectors);
  return mergedProps;
}

function getMergedPropsFromContextsArray(contexts, options, props) {
  if (props === void 0) {
    props = {};
  }

  var mergedState = {};
  var mergedActions = {};
  contexts.forEach(function (Context) {
    var context = React.useContext(Context);
    Object.assign(mergedState, context.state);
    Object.assign(mergedActions, context.actions);
  });
  var selectedState = executeParsedSelectors(options.stateSelectors, mergedState, props);
  var selectedActions = executeParsedSelectors(options.actionSelectors, mergedActions, props);
  var mergedProps = getMergedProps(selectedState, selectedActions, props, options.computedSelectors);
  return mergedProps;
}

function getMergedProps(selectedState, selectedActions, props, computedSelectors) {
  if (computedSelectors === void 0) {
    computedSelectors = {};
  }

  var mergedProps = _assign({}, selectedState, selectedActions, props);

  Object.entries(computedSelectors).forEach(function (_a) {
    var key = _a[0],
        value = _a[1];
    var fn = value[0],
        deps = value[1];
    var depValues = deps.map(function (dep) {
      return mergedProps[dep];
    });
    var memoValues = memoizableValues(depValues);
    mergedProps[key] = React.useMemo(function () {
      return fn.apply(void 0, depValues);
    }, memoValues);
  });
  return mergedProps;
}

function normalizedContextOptions(options) {
  var normalized = _assign({}, options); // DEPRECATED


  if (options.stateMappers) {
    normalized.stateSelectors = options.stateMappers;
  }

  if (options.actionMappers) {
    normalized.actionSelectors = options.actionMappers;
  }

  return normalized;
}

function memoizableValues(value) {
  if (value instanceof Array) {
    return value.filter(function (value) {
      return typeof value !== 'function';
    });
  }

  return Object.values(value).filter(function (value) {
    return typeof value !== 'function';
  });
}

var providerContextMap = new Map();

function createContextProvider() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var Context = createContext({}, customIsEqualShallow);

  var Provider = function Provider(_a) {
    var onInit = _a.onInit,
        props = __rest(_a, ["onInit"]);

    var _b, _c; // TODO: add better typing


    var contextValue = React.useRef({});
    var reducer, initialState, actionCreators;
    var state, actions, dispatch, setState;

    if (typeof args[0] === 'function') {
      reducer = args[0], initialState = args[1], actionCreators = args[2];
      _b = React.useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    } else {
      initialState = args[0], actionCreators = args[1];
      _c = React.useState(initialState), state = _c[0], setState = _c[1];
      dispatch = React.useMemo(function () {
        return createStateSetterDispatch(setState, contextValue);
      }, [initialState]);
    }

    actions = React.useMemo(function () {
      return getBindedActions(actionCreators, dispatch, contextValue);
    }, [actionCreators]);
    contextValue.current.state = Object.freeze(state);
    contextValue.current.actions = Object.freeze(actions);

    if (onInit) {
      var options_1 = onInit[0],
          onInitFn_1 = onInit[1];
      React.useMemo(function () {
        var parsedOptions = normalizedContextOptions(options_1);
        parsedOptions.stateSelectors = parseSelectors(parsedOptions.stateSelectors);
        parsedOptions.actionSelectors = parseSelectors(parsedOptions.actionSelectors);
        var selectedState = executeParsedSelectors(parsedOptions.stateSelectors, state, props);
        var selectedActions = executeParsedSelectors(parsedOptions.actionSelectors, actions, props);
        var mergedProps = getMergedProps(selectedState, selectedActions, props, parsedOptions.computedSelectors);
        onInitFn_1(mergedProps);
      }, []);
    }

    return React.createElement(Context.Provider, _assign({
      value: _assign({}, contextValue.current)
    }, props));
  };

  providerContextMap.set(Provider, Context);
  return [Provider, Context];
}

function getBindedActions(actions, dispatch, contextValue) {
  var bindedActions = {};

  var getState = function getState() {
    return contextValue.current.state;
  };

  Object.entries(actions).forEach(function (_a) {
    var key = _a[0],
        value = _a[1];
    bindedActions[key] = value(dispatch, getState);
  });
  return bindedActions;
}

function createStateSetterDispatch(dispatch, contextValue) {
  return function (params) {
    var newState = _assign({}, contextValue.current.state, params);

    dispatch(newState);
  };
}

function getProviderContext(Provider) {
  var Context = providerContextMap.get(Provider);

  if (!Context) {
    throw "Context not found for Provider " + Provider;
  }

  return Context;
}

var customIsEqualShallow = function customIsEqualShallow(stateA, stateB) {
  // [0] is state values, [1] ar action creators
  return isEqualShallow(stateA[0], stateB[0]);
};

var DefaultChild = function DefaultChild(_a) {
  var children = _a.children;
  return children;
}; // DEPRECATE: just use Object notation


function getContextsFromProviderCollection(providers) {
  if (providers instanceof Array) {
    return providers.map(function (Provider) {
      return getProviderContext(Provider);
    });
  }

  return Object.keys(providers).reduce(function (contexts, key) {
    contexts[key] = getProviderContext(providers[key]);
    return contexts;
  }, {});
}

function createMergedStore(providers) {
  var contexts = getContextsFromProviderCollection(providers);
  var withStore = mergedConnectContextFactory(contexts);
  var useStore = useMergedConnectedContextFactory(contexts);

  var MergedStore = function MergedStore(props) {
    // TODO: this needs to be connected or can just read the merged values from the context similar to createContextProvider onInit
    var Child = props.onInit ? getConnectedChild(withStore, props.onInit) : DefaultChild;
    var wrapper = React.createElement(Child, _assign({}, props));
    Object.values(providers).forEach(function (Provider) {
      var previousWrapper = wrapper;
      wrapper = React.createElement(Provider, null, previousWrapper);
    });
    return React.useMemo(function () {
      return wrapper;
    }, []);
  };

  return [MergedStore, withStore, useStore];
}

function getConnectedChild(withStore, onInit) {
  var options = onInit[0],
      onInitFn = onInit[1];
  return withStore(function (_a) {
    var children = _a.children,
        selectionResult = __rest(_a, ["children"]);

    React.useMemo(function () {
      onInitFn(selectionResult);
    }, []);
    return children;
  }, options);
}

function createMockProvider(Provider, Component) {
  var Context = getProviderContext(Provider);
  return function (_a) {
    var _b = _a.state,
        state = _b === void 0 ? {} : _b,
        _c = _a.actions,
        actions = _c === void 0 ? {} : _c;
    return React.createElement(Context.Provider, {
      value: {
        state: state,
        actions: actions
      }
    }, Component);
  };
}

export default createContextProvider;
export { connectContext, connectContextFactory, useConnectedContextFactory, mergedConnectContextFactory, useMergedConnectedContextFactory, createMergedStore, createMockProvider };